import { Server } from '../../server/server';
import { UIImage } from '../common/ui/uiImage';
import { UIPanel, UIPanelOptions } from '../common/ui/uiPanel';
import { UIPanelButton } from '../common/ui/uiPanelButton';
import { UIText } from '../common/ui/uiText';
import { PowerupImage, PowerUpType } from './pupListDialog';

const CD = 10; // count down time = 10s

export interface PowerupPanelOptions extends UIPanelOptions {
  callback: Function
}

export class PowerupPanel extends UIPanel {
  /**
   * Returns the state of the powerups.
   * @param plusScore for Plus Score powerup
   * @param slowMotion for Slow Motion powerup
   * @param shields for Shields powerup
   */
  protected callback: Function;

  protected slotButtons: UIPanelButton[]; 
  
  // which powerup be clicked
  protected xSlot1: number;
  protected xSlot2: number;
  protected xSlot3: number;
  protected buttonSlot1: number;
  protected buttonSlot2: number;
  protected buttonSlot3: number;

  // The powerups state
  protected multiplierActive = -1;
  protected slowMotionActive = -1;
  protected shieldsActive    = -1;
  
  // The 3 powerups timer
  protected timerMultiplier: any;
  protected timerSlowMotion: any;
  protected timerShields: any;

  // The 3 slots cooldown number
  protected cdSlot1 = -1;
  protected cdSlot2 = -1;
  protected cdSlot3 = -1;

  // The 3 slots cooldown text
  protected cdTextSlot1: UIText;
  protected cdTextSlot2: UIText;
  protected cdTextSlot3: UIText;

  // The 3 slots cooldown timer
  protected timerSlot1: any;
  protected timerSlot2: any;
  protected timerSlot3: any;

  // constructor
  constructor(options: PowerupPanelOptions) {
    options.mouseEvents = true;
    super(options);
    this.callback = options.callback;
    this.slotButtons = [];
  }

  public buildPowerups() {
    for(let i = 0; i < this.slotButtons.length; i++) 
      this.removeChild(this.slotButtons[i]);

    this.slotButtons = [];

    let slot_1 = localStorage.getItem('whacka-slot-1');
    let slot_2 = localStorage.getItem('whacka-slot-2');
    let slot_3 = localStorage.getItem('whacka-slot-3');

    this.buildSlot(slot_1, 10);
    this.buildSlot(slot_2, 60);
    this.buildSlot(slot_3, 110);
  }

  protected buildSlot(selection: any, x: number) {
    let slot_props   = this.setSlotProps(selection, x);
    let slot         = new UIPanelButton(slot_props);
    
    this.slotButtons.push(slot);

    if (selection) {
      let url        = PowerupImage.get(Number(selection));
      let img_props  = this.setSlotImageProps(url, slot);
      let slot_image = new UIImage(img_props);
    }
  }

  protected setSlotProps(selection: any, x: number) {
    let data = {
      panelColors : {normal : '#ffffff40'},
      radius : 23,
      // borderWidth : 1,
      // borderColor : '#000000',
      // textColors : {normal : '#ffffff'},
      callback : () => {
        if (selection)
          this.onPowerUpButton(Number(selection), x);
      },
      anchor : {x : 0, y : 0},
      pivot : {x : 0, y : 0},
      size : {x : 40, y : 40},
      position : {x : x, y : 5},
      parent : this
    };

    return data;
  }
  
  protected setSlotImageProps(url: string, parent: any) {
    let data = {
      url : url,
      anchor : {x : 0.5, y : 0.5},
      pivot : {x : 0.5, y : 0.5},
      position : {x : 0, y : 0},
      size : {x : 39, y : 39},
      stretch : true,
      parent : parent
    };

    return data;
  }
  
  setCDTextProps(cdSlot: number, x: number) {
    let data = {
      text : cdSlot.toString() + 's',
      fontSize: 20,
      fontWeight: '700',
      position: {x: x + 23, y: 0},
      pivot: {x: 0.5, y: 1},
      color: 'white',
      parent : this
    };

    return data;
  }

  recordCDAmount(buttonNumber: number) {
    switch (buttonNumber) {
      case PowerUpType.DoubleScore:
        this.multiplierActive = CD;
        break;
      case PowerUpType.SlowMotion:
        this.slowMotionActive = CD;
        break;
      case PowerUpType.Shields:
        this.shieldsActive = CD;
        break;
    }
  }

  startSlot1CD(buttonNumber: number, x: number) {
    if (this.cdSlot1 != -1) return;

    this.cdSlot1     = CD;
    let slot_props   = this.setCDTextProps(this.cdSlot1, x);
    this.cdTextSlot1 = new UIText(slot_props);

    this.recordCDAmount(buttonNumber);
    this.onTimerSlot1(buttonNumber, x);
  }

  startSlot2CD(buttonNumber: number, x: number) {
    if (this.cdSlot2 != -1) return;

    this.cdSlot2     = CD;
    let slot_props   = this.setCDTextProps(this.cdSlot2, x);
    this.cdTextSlot2 = new UIText(slot_props);

    this.recordCDAmount(buttonNumber);
    this.onTimerSlot2(buttonNumber, x);
  }

  startSlot3CD(buttonNumber: number, x: number) {
    if (this.cdSlot3 != -1) return;

    this.cdSlot3     = CD;
    let slot_props   = this.setCDTextProps(this.cdSlot3, x);
    this.cdTextSlot3 = new UIText(slot_props);

    this.recordCDAmount(buttonNumber);
    this.onTimerSlot3(buttonNumber, x);
  }

  onTimerSlot1(buttonNumber: number, x: number) {
    this.onTimerPowerup(buttonNumber);

    this.timerSlot1 = setInterval(() => {
      this.cdSlot1--;
      this.cdTextSlot1.text = this.cdSlot1.toString() + 's';

      if (this.cdSlot1 === -1) {
        clearInterval(this.timerSlot1);
        this.removeChild(this.cdTextSlot1);
        this.clearIcon(x);
        this.buildPowerups();
      }
    }, 1000);
  }

  onTimerSlot2(buttonNumber: number, x: number) {
    this.onTimerPowerup(buttonNumber);

    this.timerSlot2 = setInterval(() => {
      this.cdSlot2--;
      this.cdTextSlot2.text = this.cdSlot2.toString() + 's';

      if (this.cdSlot2 === -1) {
        clearInterval(this.timerSlot2);
        this.removeChild(this.cdTextSlot2);
        this.clearIcon(x);
        this.buildPowerups();
      }
    }, 1000);
  }

  onTimerSlot3(buttonNumber: number, x: number) {
    this.onTimerPowerup(buttonNumber);

    this.timerSlot3 = setInterval(() => {
      this.cdSlot3--;
      this.cdTextSlot3.text = this.cdSlot3.toString() + 's';

      if (this.cdSlot3 === -1) {
        clearInterval(this.timerSlot3);
        this.removeChild(this.cdTextSlot3);
        this.clearIcon(x);
        this.buildPowerups();
      }
    }, 1000);
  }

  onTimerPowerup(buttonNumber: number) {
    switch (buttonNumber) {
      case PowerUpType.DoubleScore:
        this.myCallback();
        Server.user.consumeAsset('whacka-double-score', 1);

        if (!this.timerMultiplier) {
          this.timerMultiplier = setInterval(() => {
            this.multiplierActive--;
            
            if (this.multiplierActive == -1) {
              clearInterval(this.timerMultiplier);
              this.timerMultiplier = null;
              this.myCallback();
            }
          }, 1000);
        }
        break;

      case PowerUpType.SlowMotion:
        this.myCallback();
        Server.user.consumeAsset('whacka-slow-motion', 1);

        if (!this.timerSlowMotion) {
          this.timerSlowMotion = setInterval(() => {
            this.slowMotionActive--;

            if (this.slowMotionActive == -1) {
              clearInterval(this.timerSlowMotion);
              this.timerSlowMotion = null;
              this.myCallback();
            }
          }, 1000);
        }
        break;

      case PowerUpType.Shields:
        this.myCallback();
        Server.user.consumeAsset('whacka-shields', 1);

        if (!this.timerShields) {
          this.timerShields = setInterval(() => {
            this.shieldsActive--;

            if (this.shieldsActive == -1) {
              clearInterval(this.timerShields);
              this.timerShields = null;
              this.myCallback();
            }
          }, 1000);
        }
        break;
    }
  }

  /**
   * Called when a power up button is pressed.
   * @param buttonNumber - Button number pressed
   * @param x - Which slot is pressed
   */
  onPowerUpButton(buttonNumber: number, x: number) {
    switch (x) {
      case 10:
        this.startSlot1CD(buttonNumber, x);
        this.buttonSlot1 = buttonNumber;
        this.xSlot1 = x;
        break;

      case 60:
        this.startSlot2CD(buttonNumber, x);
        this.buttonSlot2 = buttonNumber;
        this.xSlot2 = x;
        break;

      case 110:
        this.startSlot3CD(buttonNumber, x);
        this.buttonSlot3 = buttonNumber;
        this.xSlot3 = x;
        break;
    }
  }

  clearIcon(x: number) {
    switch (x) {
      case 10:
        localStorage.removeItem('whacka-slot-1');
        break;
      case 60:
        localStorage.removeItem('whacka-slot-2');
        break;
      case 110:
        localStorage.removeItem('whacka-slot-3');
        break;
    }
  }

  private myCallback() {
    this.callback(this.multiplierActive, this.slowMotionActive, this.shieldsActive);
  }

  public pause() {
    clearInterval(this.timerSlot1);
    clearInterval(this.timerSlot2);
    clearInterval(this.timerSlot3);

    clearInterval(this.timerMultiplier);
    clearInterval(this.timerSlowMotion);
    clearInterval(this.timerShields);

    this.timerMultiplier = null;
    this.timerSlowMotion = null;
    this.timerShields = null;
  }

  public resume() {
    if (this.cdSlot1 != -1)
      this.onTimerSlot1(this.buttonSlot1, this.xSlot1);

    if (this.cdSlot2 != -1)
      this.onTimerSlot2(this.buttonSlot2, this.xSlot2);

    if (this.cdSlot3 != -1)
      this.onTimerSlot3(this.buttonSlot3, this.xSlot3);
  }

  public reset() {
    this.removeChild(this.cdTextSlot1);
    this.removeChild(this.cdTextSlot2);
    this.removeChild(this.cdTextSlot3);

    clearInterval(this.timerSlot1);
    clearInterval(this.timerSlot2);
    clearInterval(this.timerSlot3);

    this.timerMultiplier = null;
    this.timerSlowMotion = null;
    this.timerShields = null;

    this.cdSlot1 = -1;
    this.cdSlot2 = -1;
    this.cdSlot3 = -1;

    this.multiplierActive = -1;
    this.slowMotionActive = -1;
    this.shieldsActive    = -1;
    
    this.myCallback();
  }
}